/**
 * Viewport entrance for comparison table header. Geometry-based threshold (tall-safe).
 * Observes .comparison-table__header.
 */
(function () {
  var SEL = '.comparison-table--intro-reveal';

  function revealApi() {
    return window.R3NU && window.R3NU.reveal ? window.R3NU.reveal : null;
  }

  function shouldRevealGeometry(el, entry) {
    var api = revealApi();
    if (api) return api.shouldReveal(el, entry);
    return entry && entry.isIntersecting;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function detachListeners(root) {
    if (root._comparisonTableIntroRevealIO) {
      root._comparisonTableIntroRevealIO.disconnect();
      root._comparisonTableIntroRevealIO = null;
    }
    if (root._comparisonTableIntroRevealOnScroll) {
      window.removeEventListener('scroll', root._comparisonTableIntroRevealOnScroll, { capture: true });
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('scroll', root._comparisonTableIntroRevealOnScroll);
      }
      root._comparisonTableIntroRevealOnScroll = null;
    }
    if (root._comparisonTableIntroRevealOnResize) {
      window.removeEventListener('resize', root._comparisonTableIntroRevealOnResize);
      root._comparisonTableIntroRevealOnResize = null;
    }
  }

  function reveal(root) {
    root.classList.add('comparison-table--intro-revealed');
    detachListeners(root);
  }

  function teardown(root) {
    detachListeners(root);
  }

  function init(root) {
    if (!root || root.dataset.comparisonTableIntroRevealInit) return;
    root.dataset.comparisonTableIntroRevealInit = 'true';

    if (prefersReducedMotion()) {
      reveal(root);
      return;
    }

    if (root.classList.contains('comparison-table--intro-revealed')) return;

    var headerEl = root.querySelector('.comparison-table__header');
    if (!headerEl || headerEl.offsetHeight < 1) {
      reveal(root);
      return;
    }

    var api = revealApi();
    var rootMargin = api ? api.getRootMargin() : '0px 0px 12% 0px';
    var thresholdList = api ? api.buildThresholdList() : [0, 0.1, 0.2, 0.5, 1];

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== headerEl) return;
          if (shouldRevealGeometry(headerEl, entry)) reveal(root);
        });
      },
      { threshold: thresholdList, rootMargin: rootMargin }
    );
    io.observe(headerEl);
    root._comparisonTableIntroRevealIO = io;

    function onResize() {
      if (root.classList.contains('comparison-table--intro-revealed')) return;
      if (shouldRevealGeometry(headerEl, null)) reveal(root);
    }
    root._comparisonTableIntroRevealOnResize = onResize;
    window.addEventListener('resize', onResize, { passive: true });

    function onScrollRaf() {
      if (root.classList.contains('comparison-table--intro-revealed')) return;
      requestAnimationFrame(function () {
        if (root.classList.contains('comparison-table--intro-revealed')) return;
        try {
          if (root._comparisonTableIntroRevealIO) {
            root._comparisonTableIntroRevealIO.takeRecords().forEach(function (entry) {
              if (entry.target === headerEl && shouldRevealGeometry(headerEl, entry)) reveal(root);
            });
          }
        } catch (e) {}
        if (!root.classList.contains('comparison-table--intro-revealed') && shouldRevealGeometry(headerEl, null)) {
          reveal(root);
        }
      });
    }
    root._comparisonTableIntroRevealOnScroll = onScrollRaf;
    window.addEventListener('scroll', onScrollRaf, { passive: true, capture: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScrollRaf, { passive: true });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (root.classList.contains('comparison-table--intro-revealed')) return;
        if (shouldRevealGeometry(headerEl, null)) reveal(root);
      });
    });
  }

  function destroy(root) {
    delete root.dataset.comparisonTableIntroRevealInit;
    teardown(root);
  }

  function scan(scope) {
    var s = scope || document;
    s.querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) scan(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t) return;
    var el = t.matches && t.matches(SEL) ? t : t.querySelector(SEL);
    if (el) destroy(el);
  });

  function syncComparisonTableIntroInView() {
    document.querySelectorAll(SEL).forEach(function (root) {
      if (!root.dataset.comparisonTableIntroRevealInit) return;
      if (root.classList.contains('comparison-table--intro-revealed')) return;
      var headerEl = root.querySelector('.comparison-table__header');
      var io = root._comparisonTableIntroRevealIO;
      if (io && headerEl) {
        try {
          io.takeRecords().forEach(function (entry) {
            if (entry.target === headerEl && shouldRevealGeometry(headerEl, entry)) reveal(root);
          });
        } catch (e) {}
      }
      if (root.classList.contains('comparison-table--intro-revealed')) return;
      if (headerEl && shouldRevealGeometry(headerEl, null)) {
        reveal(root);
      }
    });
  }

  if (window.r3nuRegisterViewportRecheck) {
    window.r3nuRegisterViewportRecheck(syncComparisonTableIntroInView);
  }
})();
